export default ({driver: {email = ''} = {}} = {}) => email;
